module.exports = __webpack_public_path__ + "img/tiki-logo.1cad7041.png";